import React, { Component } from "react";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import { Navigate } from "react-router-dom";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import moment from "moment";
import { encryptAES } from "../../utils/Encryption";
import ValidationText from "../../utils/validation/ValidationText";
import DropdownSelect from "../../components/dropdown/Dropdown";
import SwalServices from "../../services/swalServices/SwalServices";

export default class BookingCancellation extends Component {

  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices();
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        searchType: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
      },
      actionDropdown: ["Detail"],
      route: "",
      totalResultes: "",
      bookingCancellationList: [],
      isLoading: false,
    };
  }
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getbookingsCancellationList(newPagination);
    });
  };

  getbookingsCancellationList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.BookingServices.getbookingsCancellationList(pagination).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent.itemList;
          details.map((key, index) => {
            key.actionDate = moment(key.actionDate).format("DD MMM YYYY");
            key.eventDate = moment(key.eventDate).format("DD MMM YYYY");
          });
          this.setState({ bookingCancellationList: details, totalResultes: response.responseItem.responseContent.totalCount, });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  actionClick = (index, value, option, event) => {
    if (option === "Detail") {
      if (value && value > 0) {
        this.setState({
          route:
            "/booking/BookingCancellationDetails/cancellationId?=" +
            encryptAES(value),
        });
      }
    }
  };

  actions = (element, index, value) => {
    return element !== "CancellationId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdown}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };
  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getbookingsCancellationList();
  };

  handleChange(event, identity) {
    const value = event.target.value;
    const name = event.target.name;

    if (identity === "paymentProofApproveDetails") {
      let detail = { ...this.state.paymentProofApproveDetails };
      detail[name] = value;
      this.setState({ paymentProofApproveDetails: detail });
    }
    if (identity === "pagination") {
      let page = { ...this.state.pagination };
      page.pageNo = 1;
      page[name] = value;
      this.setState({ pagination: page });
    }
    if (identity === "searchCompany") {
      let detail = { ...this.state.outstandingInvoicesRequest };
      detail[name] = value;
      this.setState({ outstandingInvoicesRequest: detail });
    }
  }

  handleChange(event) {

    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getbookingsCancellationList();
      } else if (fulldate === null) {
        this.getbookingsCancellationList();
      }
    });
  }

  componentDidMount() {
    this.getbookingsCancellationList();
  }

  render() {
    if (this.state.route != "") {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section View-booking-sec">
        <div className="filter-info grid grid-cols-12 gap-6 pt-8">
          <div className="filter-types xl:col-span-4 lg:col-span-4 col-span-12">
            <label
              className="filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
              htmlFor="default"
            >
              Event Name
            </label>
            <input
              id="searchText"
              name="searchText"
              className="form-input rounded-none w-full shadow-red py-3 text-lg"
              type="text"
              value={this.state.pagination.searchText}
              onChange={(e) => this.handleChange(e, "pagination")}
            //onBlur={() => this.validateField("tagName")}
            />
            {/* <ValidationText error={this.state.validState.error.tagName} /> */}
          </div>
          <div className="filter-types xl:col-span-4 lg:col-span-4 col-span-12">
            <label
              className=" filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
              htmlFor="default"
            >
              Type
            </label>
            <input
              id="searchType"
              name="searchType"
              className="form-input rounded-none w-full shadow-red py-3 text-lg"
              type="text"
              value={this.state.pagination.searchType}
              onChange={(e) => this.handleChange(e, "pagination")}
            //   onBlur={() => this.validateField("tagName")}
            />
            {/* <ValidationText error={this.state.validState.error.tagName} /> */}
          </div>
        </div>
        <div className="top-filter-sec mt-4">
          <div className="date-label">Submission Date Range</div>
          <div className="flex justify-between pb-7">
            <div className="left-date">
              <div className="grid grid-cols-12 gap-6 items-center w-full">
                <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                  <input
                    id="default"
                    name="dateFrom"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateFrom}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                <div className=" 2xl:col-span-2 lg:col-span-2 col-span-12 w-full text-center">
                  <h2 className="text-xl theme-color">To</h2>
                </div>
                <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                  <input
                    id="default"
                    name="dateTo"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateTo}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>
            <div className="right-search flex items-center">
              <button
                className="col-end-8 col-span-1  w-32 px-7 py-2 btn-sm btn-red text-lg text-white font-bold"
                onClick={() => this.getbookingsCancellationList()}
              >
                Search
              </button>
            </div>
          </div>
          <Table
            columns={[

              { name: "bookingReferenceNo", title: "Ref. No." },
              { name: "eventName", title: "Event Name" },
              { name: "eventDate", title: "Event Date" },
              { name: "attendeeName", title: "Attendee Name" },
              { name: "requestType", title: "Request Type" },
              { name: "status", title: "Status" },
              { name: "actionDate", title: "Action Date" },
              { name: "CancellationId", title: "" },

            ]}
            rows={this.state.bookingCancellationList}
            isLoading={this.state.isLoading}
            sortingColumns={["BookingReferenceNo"]}
            pagination={this.state.pagination}
            totalResultes={this.state.totalResultes}
            totalCount={this.state.totalResultes}
            setPagination={this.setPagination.bind(this)}
            customScope={[
              {
                column: "CancellationId",
                renderTableData: this.actions.bind(this),
              },
              // {
              //     column: "selectRow",
              //     renderTableData: this.select.bind(this),
              //     valueColumnName: "chartsOfAccountsId",
              // },
            ]}
          />
        </div>
      </div>
    );
  }
}
